import React from "react";
import type { FieldSchema, OperatorValue, RowState, Option } from "../../types";
import { FieldSelect } from "./FieldSelect";
import { OperatorSelect } from "./OperatorSelect";
import { ConditionValue } from "./ConditionValue";
import { AddRemoveButtons } from "./AddRemoveButtons";

interface Props {
  row: RowState;
  isFirst: boolean;
  fields: FieldSchema[];
  fieldOptions: Option[];
  operators: OperatorValue[];
  operatorError?: string;
  onChangeField: (fieldName: string) => void;
  onChangeOperator: (op: OperatorValue) => void;
  onAdd: () => void;
  onRemove: () => void;
  onClearValue: (which: "value" | "value2") => void;
  disableAdd?: boolean;
  dropdownPortalId?: string;
  shortDateFormat?: string;
}

export const AdvanceSearchRow: React.FC<Props> = ({
  row,
  isFirst,
  fields,
  fieldOptions,
  operators,
  operatorError,
  onChangeField,
  onChangeOperator,
  onAdd,
  onRemove,
  onClearValue,
  disableAdd,
  dropdownPortalId,
  shortDateFormat
}) => {
  return (
    <div className="grid gap-3 rounded-lg bg-white md:grid-cols-[minmax(150px,0.85fr)_minmax(140px,0.75fr)_minmax(260px,1fr)_auto] md:items-start">
      <FieldSelect row={row} fieldOptions={fieldOptions} onChangeField={onChangeField} />

      <OperatorSelect
        row={row}
        operators={operators}
        onChangeOperator={onChangeOperator}
        error={operatorError}
      />

      <ConditionValue
        row={row}
        fields={fields}
        onClearValue={onClearValue}
        dropdownPortalId={dropdownPortalId}
        shortDateFormat={shortDateFormat}
      />

      <div className="flex h-full">
        <AddRemoveButtons isFirst={isFirst} onAdd={onAdd} onRemove={onRemove} disableAdd={disableAdd} />
      </div>
    </div>
  );
};
